import { useApiQuery } from '../useApiQuery'

export function useTopics (tags) {
  const {
    data: topics,
    isLoading: loadingTopics,
    error: topicsError
  } = useApiQuery(
    ['topics', tags],
    'schools',
    `topics?filter[tags]=${tags}`,
    {
      enabled: Boolean(tags)
    }
  )

  return [topics, loadingTopics, topicsError]
}
